import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { signIn, setUserInfo, logOut } from "./index";

export const loginWithFirebase = (email, password) => async (dispatch) => {
  try {
    console.log("🔐 Logging in with Firebase...");

    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    console.log("✅ User authenticated:", user.email);

    const tokenResult = await user.getIdTokenResult();
    const token = tokenResult.token;
    const role = tokenResult.claims.role || "user";

    console.log("🎟️ Token:", token);
    console.log("🧾 Role from custom claims:", role);

    if (role !== "admin") {
      return {
        success: false,
        error: "⛔ Accès refusé : cet utilisateur n'est pas un administrateur."
      };
    }

    sessionStorage.setItem("token", token);
    sessionStorage.setItem("userData", JSON.stringify({
      userId: user.uid,
      userEmail: user.email,
      userRole: role,
    }));

    dispatch(signIn(token));
    dispatch(setUserInfo({
      userId: user.uid,
      userEmail: user.email,
      userRole: role,
    }));

    console.log("🧠 User state updated in Redux.");

    return { success: true };
  } catch (error) {
    console.error("❌ Firebase login error:", error.message);

    let message = "Erreur de connexion. Veuillez vérifier vos identifiants.";
    if (error.code === "auth/user-not-found") {
      message = "Utilisateur introuvable.";
    } else if (error.code === "auth/wrong-password") {
      message = "Mot de passe incorrect.";
    }

    return {
      success: false,
      error: message,
    };
  }
};

export const logoutFirebase = () => async (dispatch) => {
  await signOut(auth);
  sessionStorage.clear();
  dispatch(logOut());
};
